import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {ModalComponent} from "../../modals/modal/modal.component";

import * as $ from "jquery";
import {User} from "../../user";
import {TranslationService} from "../../../services/translation.service";

@Component({
  selector: 'app-top-navigation',
  templateUrl: './top-navigation.component.html',
  styleUrls: ['./top-navigation.component.css']
})
export class TopNavigationComponent implements OnInit {
    user: User
    isUserDropdownOpen: boolean;
    floatPanelMode:string;
    modalRef: BsModalRef;

  constructor(
      private http: HttpClient,
      private modalService: BsModalService,
      private translationService: TranslationService
  ) { }

  ngOnInit() {
      this.http
          .get('/user/get' ).subscribe(
              (user:User) => {
                 if(user.id){
                     this.user = user;
                     this.floatPanelMode = 'info';
                 }else{
                     this.user = new User();
                     this.floatPanelMode = 'login';
                 }
              }
      );
      this.user = new User();
      this.floatPanelMode = 'registration';
      $(document).click( (e) => {
          if ($(e.target).closest($('.navbar-custom-menu')).length) return;
          this.isUserDropdownOpen = false;
      });
  }

  rememberPassword(form) {
      console.log('Password request send');
      if(!form.form.valid){
          this._handleError(this.translationService.translate('uploader-error-4'));
          return;
      }

      this.http
          .post('/user/remember-password', this.user ).subscribe(
          (user:User) => {
              if(user.id){
                  this.floatPanelMode = 'password-send';
              }
          }, (error) => {
              this._handleError(error.error.message);
          }
      );
  }

  login(form) {
      if(!form.form.valid){
          this._handleError(this.translationService.translate('uploader-error-4'));
          return;
      }

      this.http
          .post('/user/login', this.user ).subscribe(
          (user:User) => {
              if(user.id){
                  this.user = user;
                  this.floatPanelMode = 'info';
              }else{
                  this.floatPanelMode = 'registration';
              }
          }, (error) => {
              this._handleError(error.error.message);
          }
      );
  }

  create(form) {
      if(!form.form.valid){
          this._handleError(this.translationService.translate('uploader-error-4'));
          return;
      }

      this.http
          .post('/user/create', this.user ).subscribe(
          (user:User) => {
              if(user.id){
                  this.user = user;
                  this.floatPanelMode = 'info';
              }else{
                  this.floatPanelMode = 'registration';
              }
          }, (error) => {
              this._handleError(error.error.message);
          }
      );
  }

  logout() {
      this.http
          .get('/user/logout').subscribe(
          (user:User) => {
              this.user = new User();
              this.floatPanelMode = 'login';
          }, (error) => {
              this._handleError(error.error.message);
          }
      );
  }

  toggleNavigationMenu() {
    $('body').toggleClass('sidebar-collapse').toggleClass('sidebar-open');
  }

  _handleError(error) {
      const initialState = {
          title: 'Error!',
          type: 'danger',
          text: error
      };
      this.modalRef = this.modalService.show(ModalComponent, {initialState});
  }

  toggleUserMenu() {

  }
}
